import { render, staticRenderFns } from "./ShareFacebookComponent.vue?vue&type=template&id=74249434&scoped=true&"
import script from "./ShareFacebookComponent.vue?vue&type=script&lang=js&"
export * from "./ShareFacebookComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74249434",
  null
  
)

export default component.exports